import {utils, rawRenderingLib} from '@wallaby-ui/core';
import classNames from 'classnames';

import {DocumentLink} from 'src/js/containers/file/components/DocumentLink';
import styles from 'src/js/containers/file/components/DocumentLink.less';
import {baseDocumentLinkParams} from 'src/js/lib/raw_rendering/base_document_link_params';

/**
 * Returns raw DOM element version of DocumentLink component.
 * @param params
 * @param services
 * @returns {Element}
 */
export default function documentLinkRenderer(params, services = {}) {
  const {children, suppressPadding, titleText, hrefTo, isAllowed} =
    baseDocumentLinkParams(
      params,
      services,
      utils.componentUtils.getDisplayName(DocumentLink)
    );

  const spanElem = document.createElement('span');
  spanElem.className = classNames(styles.dlDocumentLink, {
    [styles.dlDocumentLinkLayout]: !suppressPadding,
  });
  if (isAllowed) {
    const linkElem = rawRenderingLib.reactRouterLinkRenderer(
      {children, title: titleText, tabIndex: 0, to: hrefTo},
      services
    );
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
      spanElem,
      linkElem
    );
  } else {
    rawRenderingLib.RawRenderingService.appendChildNodeOrHtml(
      spanElem,
      children
    );
  }

  return spanElem;
}
